/**
 * Release metadata for Settings, App Information, feedback, and tooling.
 * CI can override via REACT_APP_VERSION and REACT_APP_BUILD_NUMBER.
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires -- package.json has no TS module
const pkg = require('../../package.json') as { version: string };

export const APP_VERSION: string = process.env.REACT_APP_VERSION || pkg.version || '0.0.0';

/** Integer build / CFBundleVersion style — shown as “build N” in UI */
export const APP_BUILD_NUMBER: string =
  process.env.REACT_APP_BUILD_NUMBER != null && process.env.REACT_APP_BUILD_NUMBER !== ''
    ? String(process.env.REACT_APP_BUILD_NUMBER)
    : '31';

/** Settings subtitle and App Info primary line */
export const APP_VERSION_LABEL = `${APP_VERSION} (build ${APP_BUILD_NUMBER})`;

/** Stored with feedback / support tickets */
export const APP_VERSION_FULL = APP_VERSION_LABEL;
